export enum AiQueryTarget {
  Propipe = 'Propipe',
}

export const AiQueryTargetMentionMap: Readonly<Record<string, AiQueryTarget>> =
  {
    '@propipe': AiQueryTarget.Propipe,
  };

export const AiQueryTargetToMentionMap: Readonly<
  Record<AiQueryTarget, string>
> = {
  [AiQueryTarget.Propipe]: '@propipe',
};

export function resolveAiQueryTargetFromText(
  text: string
): AiQueryTarget | null {
  if (!text) {
    return null;
  }

  for (const [mention, target] of Object.entries(AiQueryTargetMentionMap)) {
    const escapedMention = mention.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const regex = new RegExp(`(^|\\s)${escapedMention}\\b`, 'i');
    if (regex.test(text)) {
      return target;
    }
  }

  return null;
}
